import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SolutionEcoPro } from 'src/app/core/_models/solutionEcoPro';
import { requiredIfCondition } from 'src/app/core/_utils/validation';

@Component({
  selector: 'app-dialog-copy-project-ecopro',
  templateUrl: './dialog-copy-project-ecopro.component.html',
  styleUrls: ['./dialog-copy-project-ecopro.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogCopyProjectEcoProComponent implements OnInit {
  solutionsTarget?: SolutionEcoPro[];
  form: any;
  newSolution: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogCopyProjectEcoProComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.form = this.formBuilder?.group({
      solutionTarget: [null],
      newSolutionTarget: ['', (control: AbstractControl) => requiredIfCondition(this.newSolution, control, 'Le champ Nom du nouveau scénario est requis.')],
      newSolution: [false]
    });

    this.solutionsTarget = this.data.solutionsTarget;
  }

  get formCrls() {
    return this.form?.controls;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  newSolutionChange(event: any) {
    this.newSolution = event.checked;
    if (!this.newSolution) this.form.patchValue({ newSolution: this.form.get('newSolution')?.value });
  }
}
